<template>
<PattanButton :states="buttonStates" :startState="0" />
</template>

<script>
import PattanButton from '@/components/PattanButton'
import {useApiStore} from "@/store/api.js"

export default {
    name: 'MaterialButton',

    components: {
        PattanButton,
    },

    data() {
        return {
            apiStore: useApiStore(),
            buttonStates: [

                {
                    label: 'Add attendee materials',
                    color: 'var(--phoenix-link-color)',
                    onClick: this.addButtonClickHandler,
                },
            ],
        }
    },

    methods: {
        addButtonClickHandler() {
            this.$router.push({ name: 'materialview', params: { sessionId: this.sessionId } })
        },
    },

    props: {
        sessionId: Number,
    }
}
</script>
<style scoped>
.btn {
    width: 15em;
}
</style>
